import { LocalStorageService } from './../../../services/localStorage/localStorage.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { MobileLoginComponentComponent } from '../mobile-login-component/mobile-login-component.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { AirportListComponent } from '../../airport/airport-list/airport-list.component';
import { AddressSelectorModalComponent } from '../address-selector-modal/address-selector-modal.component';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { LocationService } from 'src/app/services/location/location.service';
@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.scss'],
})
export class HeaderComponentComponent implements OnInit {
  @Input() headerData: any = [];
  @Output() closeModal? = new EventEmitter<Event>();
  @Output() updateAirportDataTrigger? = new EventEmitter<any>();
  @Output() updateLocationDataTrigger? = new EventEmitter<any>();
  @Output() backButtonClick? = new EventEmitter<void>();

  public location: string;
  public timeDifferenceInMinutes: number;
  public airportInfo: any;
  public selectedAirport: string;
  public partnerPid: string;
  public isGuestUser = false;

  ngOnChanges(){
    this.headerData = this.headerData;
    this.selectedAirport = this.headerData?.selectedAirport;
    if (
      !localStorage.getItem(localStorageKeys.ADDRESS) ||
      this.locationService.checkIfStaleLocation()
    ) {
      this.locationService.getCurrentLocation();
    }
    const address = JSON.parse(
      this.localStorageService.getItem(localStorageKeys.ADDRESS)
    );

    if (this.headerData?.showLocation) {
      this.location = address?.formatted_address;
    }
    this.isGuestUser = this.authService.checkIfGuestUser();
  }

  constructor(
    private analyticsService: AnalyticsService,
    private modalController: ModalController,
    private localStorageService: LocalStorageService,
    private locationService: LocationService,
    private themeService: ThemeService,
    private navController: NavController,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.partnerPid = this.themeService.getAppPid;
    this.selectedAirport = this.headerData?.selectedAirport;
    if (
      !localStorage.getItem(localStorageKeys.ADDRESS) ||
      this.locationService.checkIfStaleLocation()
    ) {
      this.locationService.getCurrentLocation();
    }
    const address = JSON.parse(
      this.localStorageService.getItem(localStorageKeys.ADDRESS)
    );

    if (this.headerData?.showLocation) {
      // if (this.getFormattedLine2(address?.line2) !== '') {
      //   this.location = this.getFormattedLine2(address?.line2);
      // } else {
      this.location = address?.formatted_address;
      // }
    }
    this.isGuestUser = this.authService.checkIfGuestUser();
  }

  async openLoginModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: MobileLoginComponentComponent,
      cssClass: 'login-modal',
      backdropDismiss: true,
      showBackdrop: true,
      initialBreakpoint: 1,
    });

    modal.onDidDismiss().then((data) => {
      if (data.data?.success) {
        this.isGuestUser = this.authService.checkIfGuestUser();
      }
    });
    await modal.present();
  }

  async presentModal() {
    this.analyticsService.trackUnified('airport_select_modal_opened', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'airport-list-component',
      button: 'select-airport-button',
    });

    const modal = await this.modalController.create({
      component: AirportListComponent,
      componentProps: {
        type: this.headerData?.service,
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then(async (data) => {
      this.updateAirportDataTrigger.emit(data?.data);
    });
    return await modal.present();
  }

  updateModalClose() {}

  modalClose() {
    this.analyticsService.trackUnified('header_close_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'header-component',
      button: 'Close-Button',
    });
    this.closeModal.emit();
  }

  async presentLocationModal() {
    this.analyticsService.trackUnified('location_select_modal_opened', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'address-selector-modal',
      button: 'select-airport-button',
    });
    const modal = await this.modalController.create({
      component: AddressSelectorModalComponent,
      componentProps: {
        type: 'LOUNGES',
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then(async (data) => {
      if (data?.data) {
        if (data?.data?.address) {
          this.localStorageService.setItem(
            localStorageKeys.ADDRESS,
            JSON.stringify(data?.data?.address)
          );
        }
        if (data?.data?.latlong) {
          this.localStorageService.setItem(
            localStorageKeys.LAT_LONG_DATA,
            JSON.stringify(data?.data?.latlong)
          );
        }
        this.location = data?.data?.address?.formatted_address;
        this.updateLocationDataTrigger.emit(this.location);
      }
    });
    return await modal.present();
  }

  getFormattedLine2(line2) {
    const result = line2.replace(/[^\w\s]/gi, '');
    return result;
  }

  onEditButtonClick() {
    if (this.headerData?.editPageLink) {
      this.navController.navigateForward(this.headerData.editPageLink);
    }
  }
}
